export default {"internalViewContainer":"_4dbh8","internalView":"Glw7W","head":"qSaKA","cover":"JTqGe","textOverflow":"S1iut"};